export const STANDARD_NOTIFICATION = "STANDARD_NOTIFICATION";
export const WARNING_NOTIFICATION = "WARNING_NOTIFICATION";
export const SUCCESS_NOTIFICATION = "SUCCESS_NOTIFICATION";
